export enum PostLoginWorkflow {
  Default = 'default',
  OpenIdConnect = 'open-id-connect',
  KaseyaCommunity = 'kaseya-community',
  KaseyaZendeskLogin = 'zendesk-login',
  KaseyaStore = 'kaseya-store',
}
